import { trigger, transition, style, animate } from '@angular/animations';
import { Component, ElementRef, HostListener, Input, viewChild, viewChildren } from '@angular/core';
import { CustomFlexLayoutModule } from '../../../flex-layout/custom-flex-layout.module';
import { MatIconModule } from '@angular/material/icon';
import { environment } from '../../../../environments/environment.prod';
import { CommonService } from '../../../services/common.service';
import { NgOptimizedImageComponent } from '../ng-optimized-image/ng-optimized-image.component';

@Component({
    selector: 'calsoft-animate-scroll-two',
    imports: [CustomFlexLayoutModule,NgOptimizedImageComponent, MatIconModule],
    templateUrl: './animate-scroll-two.component.html',
    styleUrl: './animate-scroll-two.component.scss',
    animations: [
        trigger('slideUp', [
            transition(':enter', [
                style({ bottom: '-100%', opacity: 0 }),
                animate('1s ease-in-out', style({ bottom: '0%', opacity: 1 }))
            ]),
            transition(':leave', [
                animate('1s ease-in-out', style({ bottom: '100%', opacity: 0 }))
            ])
        ])
    ]
})
export class AnimateScrollTwoComponent {


    @Input() data: any;
    @Input() item: any;
    @Input() images: any;
    constructor(private commonService: CommonService,) {


        if (this.images?.length > 0) {
            this.currentImage = this.images[this.currentImageIndex];
        }
    }

    public bannerServerPath = environment.commonImageApi + '/commonSlider/';

    public serverPath1 = environment.commonImageApi + '/home/';


    readonly scrollContainer = viewChild<ElementRef>('scrollContainer');
    readonly progressBar = viewChild<ElementRef>('progressBar');
    ngOnInit() {
        if (this.images.length > 0) {
            this.currentImage = this.images[0]; // Set the first image initially
        }
        this.updateProgressBar(); // Ensure progress is set
    }

    ngAfterViewInit() {
        this.updateProgressBar();
        this.detectActiveSection();
        this.setupIntersectionObserver();

        const containerRef = this.scrollContainer?.(); // Optional chaining
        const container = containerRef?.nativeElement as HTMLElement | null;

        if (!container) return; // Exit if undefined

        // Enable smooth touch scrolling
        let touchStartX = 0;
        let touchMoveX = 0;

        container.addEventListener('touchstart', (e: TouchEvent) => {
            touchStartX = e.touches[0].clientX;
        });

        container.addEventListener('touchmove', (e: TouchEvent) => {
            touchMoveX = e.touches[0].clientX;
        });

        container.addEventListener('touchend', () => {
            const difference = touchStartX - touchMoveX;

            const firstChild = container.children[0] as HTMLElement | undefined;
            const totalItems = firstChild?.children?.length || 0;

            if (Math.abs(difference) > 50) {
                if (difference > 0 && this.currentIndex < totalItems - 1) {
                    this.currentIndex++;
                } else if (difference < 0 && this.currentIndex > 0) {
                    this.currentIndex--;
                }
            }

            this.smoothScrollTo(this.currentIndex);
        });
    }

    setupIntersectionObserver() {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const index = this.sectionItems().findIndex(
                            (el) => el.nativeElement === entry.target
                        );
                        if (index !== -1) {
                            this.currentImageIndex = index;
                            this.currentImage = this.images[this.currentImageIndex];
                            this.prevImage = index > 0 ? this.images[index - 1] : null;

                            this.updateProgressBar();
                        }
                    }
                });
            },
            { threshold: 0.6 }
        );

        this.sectionItems().forEach((section) => observer.observe(section.nativeElement));
    }

    link(url: any) {

        this.commonService.goToLink(url)

    }

    readonly sectionItems = viewChildren<ElementRef>('sectionItem');
    currentImageIndex = 0;
    detectActiveSection() {
        let index = 0;
        this.sectionItems().forEach((section, i) => {
            const rect = section.nativeElement.getBoundingClientRect();
            if (rect.top >= 0 && rect.top < window.innerHeight / 2) {
                index = i;
            }
        });

        if (index !== this.currentImageIndex) {
            this.currentImageIndex = index;
        }
    }

    private lastScrollY = 0;
    private ticking = false;
    @HostListener("window:scroll", [])
    onScroll() {
        const currentScrollTop = window.scrollY;

        // Detect scroll direction
        if (currentScrollTop > this.lastScrollY) {
            // Scrolling Down
            this.updateProgressBar();
        } else {
            // Scrolling Up - Reverse Progress
            this.updateProgressBar();
        }

        this.lastScrollY = currentScrollTop; // Update last scroll position
    }

    prevImage: any = null;
    currentImage: any = null;
    nextImage() {
        if (this.currentImageIndex < this.images.length - 1) {
            this.prevImage = this.currentImage;
            this.currentImageIndex++;
            this.currentImage = this.images[this.currentImageIndex];


            setTimeout(() => {
                this.prevImage = null;
            }, 3000);
        }
    }

    updateProgressBar() {
        const scrollContainer = this.scrollContainer();
        const sectionItems = this.sectionItems();
        const progressBar = this.progressBar();
        if (!scrollContainer || !progressBar || !sectionItems) return;

        const scrollableElement = scrollContainer.nativeElement;
        const sections = sectionItems;
        const totalSections = sections.length;

        if (totalSections === 0) return;

        let currentSectionIndex = 0;
        sections.forEach((section, index) => {
            const rect = section.nativeElement.getBoundingClientRect();
            if (rect.top >= 0 && rect.top < window.innerHeight / 2) {
                currentSectionIndex = index;
            }
        });

        let progress = (currentSectionIndex / (totalSections - 1)) * 100;
        if (progress > 100) progress = 100;
        if (progress < 0) progress = 0;

        progressBar.nativeElement.style.transition = "height 0.5s ease-out";
        progressBar.nativeElement.style.height = `${progress}%`;


        if (this.currentImageIndex === -1) {
            this.currentImageIndex = 0;
            this.currentImage = this.images[0];
        }

        if (currentSectionIndex !== this.currentImageIndex) {
            this.currentImageIndex = currentSectionIndex;
            this.updateRightSideImage();
        }
    }


    updateRightSideImage() {
        if (this.currentImageIndex >= this.images.length) return;

        this.prevImage = this.currentImage;
        this.currentImage = this.images[this.currentImageIndex];


        if (this.currentImageIndex === this.images.length - 1) {
            this.currentImage = this.images[this.images.length - 1];
        }


        setTimeout(() => {
            this.prevImage = null;
        }, 500);
    }



    readonly scrollContainerTwo = viewChild<ElementRef>('scrollContainer');
    currentIndex = 0;
    smoothScrollTo(index: number) {
        const containerRef = this.scrollContainer();
        const container = containerRef?.nativeElement as HTMLElement | null;

        if (!container) return; // Guard clause for safety

        const targetPos = index * window.innerWidth;
        container.scrollTo({ left: targetPos, behavior: 'smooth' });
    }

}
